export default "__VITE_ASSET__DyqX2dAP__"